import { createContext, useContext, useEffect, useMemo, useState } from "react";
import { api, tokenStore } from "../lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null = checking, false = anon, object = logged
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = tokenStore.get();
    if (!token) {
      setUser(false);
      setLoading(false);
      return;
    }
    api.get("/auth/me")
      .then((r) => setUser(r.data))
      .catch(() => { tokenStore.clear(); setUser(false); })
      .finally(() => setLoading(false));
  }, []);

  const login = async (email, password, turnstile_token) => {
    const { data } = await api.post("/auth/login", { email, password, turnstile_token });
    tokenStore.set(data.access_token);
    setUser({ id: data.id, email: data.email, name: data.name, role: data.role });
    return data;
  };

  const logout = async () => {
    try { await api.post("/auth/logout"); } catch (err) {
      // Logout is a client-side operation; a network failure shouldn't block
      // the user from being signed out locally.
      console.warn("auth: logout request failed", err?.message || err);
    }
    tokenStore.clear();
    setUser(false);
  };

  return (
    <AuthContext.Provider value={useMemo(() => ({ user, loading, login, logout }), [user, loading])}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  return useContext(AuthContext);
}
